import { render } from "./AdyenBancontactCardForm.vue?vue&type=template&id=13918247"
import script from "./AdyenBancontactCardForm.vue?vue&type=script&lang=js"
export * from "./AdyenBancontactCardForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__